import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { orderBy } from '@progress/kendo-data-query';
import { LabelService } from '~/services/modules/stocks/labels';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';

  @Component({
    selector: 'barcode-label-print-preferences.component-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
  export class StocksBarcodeLabelPrintUpsertComponent implements OnInit, OnDestroy {
    _theme: string;
    _isNew: boolean;
    _active: boolean;
    _labelPreset: any[] = [];
    _labelSize: any[] = [];

    _selectdLabelPreset: any;
    _selectedLabelSize: any;
    _selectedFormName: any;

    @Input() returnUrl: string;
    // _model: any = {
    //   BarcodeValues: [],
    //   LabelSizeID: 0,
    //   Row: 0,
    //   Column: 0,
    //   LabelPresetId: 0,
    //   LabelSize: {},
    //   numberOfCopy: 1
    // };

    _model:any;
    @ViewChild('labelType') labelType: ComboBoxComponent;
    @ViewChild('labelSize') labelSize: ComboBoxComponent;
    constructor(
      private _layoutManager: LayoutManagerService,
      private _themeManager: ThemeManagerService,
      private _labelService: LabelService,
      private router: Router,

      @Inject(PORTAL_DATA) public data: any
    ) {


      // this._getLabelPreset(data?.model?.accessFrom == "asset" ? true : false);
      // this._getLabelSizes();
      if (data && data.model) {
        this._isNew = data.isNew;
        this._active = true;
        this._model={
            id:data.model._id,
            pageId: data.model.pageId,
            pageName: data.model.formname,
            labelPresetId: data.model.labeltypeId,
            labelSizeId: data.model.labelsizeId,
            labelPresetName:data.model.labeltype,
            labelSizeName:data.model.labelsize
        }
        this._selectedFormName=data.model.formname;
        // this._getLabelPresetById(data.model.labeltypeId);
        // this._getLabelSizeById(data.model.labelsizeId)
        this._getLabelPreset(data.model.formname, data.model.labeltypeId, data?.model?.accessFrom == "asset" ? true : false);
        this._getLabelSizes(data.model.labelsizeId);
      }
      else
      {
        this._getLabelPreset(null, data?.model?.accessFrom == "asset" ? true : false);
        this._getLabelSizes();
      }
      this._themeManager.themeChange.subscribe((data) => {
        this._theme = data;
      });
      this._labelService.labelAdded.subscribe(x => {
        this._labelPreset.push(x);
      })
      this._layoutManager.applyOverly();


    }

    ngOnInit() {
    }

    ngOnDestroy() {
      this._layoutManager.removeOverlay();
    }

    _onStateChanges(e: any) {
      if (e === 'minimized') {
        this._layoutManager.removeOverlay();
      } else {
        this._layoutManager.applyOverly();
      }
    }

    _onCancel() {
      this._closeForm();
    }

    _closeForm() {
      this._active = false;
      this.ngOnDestroy();
    }

    _getLabelPreset(PageName:string, LabelpresetId? : any, isAsset: boolean = false){
      this._labelService.getPresetLabel(isAsset)
            
            .subscribe((x: any[]) => {
              if(PageName)
              this._labelPreset = x.filter (x => x.pageName == PageName);
              else
              this._labelPreset = x;
              if(LabelpresetId)
              {
                var check = this._labelPreset.find(x => x.id == LabelpresetId);
                if(check)
                {
                  this._selectdLabelPreset=check;
                }
              }

            });
    }

    _getLabelSizeById(LabelSizeId?: any){
      if(LabelSizeId)
      {
        this._labelService.getLabelSizeById(LabelSizeId)
              
              .subscribe((x: any[]) => {
               // this._labelSize = x;
                //this._labelSize = orderBy(this._labelSize, [{ field: "name", dir: "desc" }]);
                this._selectedLabelSize = x;

                  // var check = this._labelSize.find(x => x.id == LabelSizeId);
                  // if(check)
                  // {
                  //   this._selectedLabelSize=check;
                  // }

              });
      }

    }

    _getLabelPresetById(LabelpresetId?: any){
      if(LabelpresetId)
      {
        this._labelService.getLabelPresetById(LabelpresetId)
              
              .subscribe((x: any[]) => {
               // this._labelPreset = x;

                  this._selectdLabelPreset = x;
                  // var check = this._labelPreset.find(x => x.id == LabelpresetId);
                  // if(check)
                  // {
                  //   this._selectdLabelPreset=check;
                  // }

              });
      }

    }
    _getLabelSizes(LabelSizeId?: any){
      this._labelService.getLabelSizes()
            
            .subscribe((x: any[]) => {
              this._labelSize = x;
              this._labelSize = orderBy(this._labelSize, [{ field: "name", dir: "desc" }]);
              if(LabelSizeId)
              {
                  var check = this._labelSize.find(x => x.id == LabelSizeId);
                  if(check)
                  {
                    this._selectedLabelSize=check;
                  }
              }

            });
    }
     _onSave()
    {
      if(this._selectdLabelPreset)
      {
        this._model.labelPresetId=this._selectdLabelPreset.id;
        this._model.labelPresetName=this._selectdLabelPreset.name;
      }

      if(this._selectedLabelSize)
      {
        this._model.labelSizeName=this._selectedLabelSize.name;
        this._model.labelSizeId=this._selectedLabelSize.id;
      }
     this._labelService.updatePrintPreferences(this._model.id,this._model)
           
           .subscribe((x: any[]) => {

            this._onCancel();
            this._labelService.labelPrintUpdated.emit();
           });
    }
    // _getLabelPreset(){
    //         
    //         .subscribe((x: any[]) => {
    //           this._labelPreset = x;
    //           this._labeltypeFocus();
    //         });
    // }

    // _getLabelSize(LabelSizeId: any){
    //   this.labelSize.disabled = false;
    //         
    //         .subscribe((x: any[]) => {
    //           this._labelSize = x;

    //           if(LabelSizeId)
    //           {
    //             var check = this._labelSize.find(x => x.id == LabelSizeId);
    //             if(check)
    //             {
    //               this._model.LabelSizeID = check;
    //               this.numbrOfCp.disabled = false;
    //               this.numbrOfCp.focus();
    //               this._model.LabelSize = check;
    //               this._model.Row = check.rows;
    //               this._model.Column = check.columns;
    //               //this._model.LabelSizeID = check.id;
    //             }
    //           }
    //           if(!LabelSizeId)
    //           {
    //             this._labelSizeFocus();
    //           }
    //           else
    //           {
    //             this.labelSize.disabled = true;
    //           }


    //         });
    // }

    // _labeltypeFocus(){
    //   this.labelType.focus();
    //   this.labelType.toggle();
    //   this.labelSize.disabled = true;
    //   this.numbrOfCp.disabled = true;
    // }
    // _labelSizeFocus(){
    //   this.labelSize.focus();
    //   this.labelSize.toggle();
    // }

  }

